import { getViteEnv } from "../config/env";

const DEFAULT_MESSAGE =
  "Hello JobScribe, I would like to know more about your services.";

export function getWhatsAppPhoneDigits() {
  const raw = getViteEnv("VITE_WHATSAPP_NUMBER");
  return raw.replace(/[^\d]/g, "");
}

/** @param {{ contactFallback?: string }} [options] */
export function buildWhatsAppUrl(options = {}) {
  const { contactFallback = "/contact" } = options;
  const phoneNumber = getWhatsAppPhoneDigits();
  const message = getViteEnv("VITE_WHATSAPP_MESSAGE") || DEFAULT_MESSAGE;

  if (!phoneNumber) {
    return contactFallback;
  }

  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
}

export function isWhatsAppUrl(url) {
  return typeof url === "string" && url.startsWith("https://wa.me/");
}
